module.exports = __webpack_public_path__ + "img/404.a778e09c.svg";